/** Eastern date (BRC's time zone) offset by `days`, as YYYY-MM-DD, whatever the viewer's computer is set to. */
export function easternISO(days = 0): string {
  const [y, m, d] = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' })
    .format(new Date()).split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}

/** Today's date in Eastern time, as YYYY-MM-DD (same as the times shown elsewhere in CAD). */
export function todayLocalISO(): string {
  return easternISO(0);
}
